/**
 * 極簡的 in-memory list 快取。
 * 有些 dataset 要 join 別的表（例如工項要接到專案名稱），同一個 list 會被好幾個
 * dataset 重複用到，這裡讓它一次 session 只打一次。切換公司時要 clear。
 */
const store = new Map<string, Promise<unknown>>();

export function cached<T>(key: string, load: () => Promise<T>): Promise<T> {
  const hit = store.get(key);
  if (hit) return hit as Promise<T>;
  const p = load().catch((e) => {
    store.delete(key);
    throw e;
  });
  store.set(key, p);
  return p as Promise<T>;
}

export function clearCache() {
  store.clear();
}

export const indexById = <T extends { id: string }>(
  rows: T[],
): Map<string, T> => new Map(rows.map((r) => [r.id, r]));
